import { PushEventOptions } from "@grafana/faro-core"
import { EventAttributes } from "@grafana/faro-react"
import { RingBuffer } from "ring-buffer-ts"

interface FaroEvent {
  name: string
  attributes?: EventAttributes
  domain?: string
  options?: PushEventOptions
  timestamp: Date
}

const BUFFER_SIZE = 100 // Maximum number of events to keep

class FaroEventStore {
  private events: RingBuffer<FaroEvent>

  constructor() {
    this.events = new RingBuffer<FaroEvent>(BUFFER_SIZE)
  }

  addEvent(name: string, attributes?: EventAttributes, domain?: string, options?: PushEventOptions) {
    const event: FaroEvent = {
      name,
      attributes,
      domain,
      options,
      timestamp: new Date(),
    }

    this.events.add(event)
  }

  getAllEvents(): FaroEvent[] {
    return this.events.toArray()
  }
}

const faroEventStore = new FaroEventStore()

export { faroEventStore }
export type { FaroEvent }
